module.exports = __webpack_public_path__ + "static/019.thumb-db7006911edae817b6108928781c7b3e.jpg";